<template>
    <div style="height:auto">
        <el-select @change="selectChanged" v-model="activeOmics" placeholder="Choose type" >
            <el-option
                v-for="item in omicsOption"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
        </el-select>
        <VennchartVue @click="click" :active-omics="activeOmics"></VennchartVue>
        <br/><br/>
        {{ this.sets }}
        <el-table id="table" ref="table" :data="tableData.slice((currentPage-1)*pageSize,currentPage*pageSize)"  @sort-change='sortChange'
            style="width: 100%;" max-height=600px :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}" >
            <el-table-column v-for='(item,key)  in vennFields' :key='key' :formatter='item.formatter' :prop='item.key' :label='item.label' :sortable="item.sortable" :width="item.width" :min-width="item.minWidth"/>          
            <el-table-column key="pmid" label="PMID" sortable="true" min-width=180>
                <template slot-scope="scope">
                    <a :href="'https://www.ncbi.nlm.nih.gov/pubmed/'+scope.row.pmid">  {{scope.row.pmid}}  </a>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="(val) => handleSizeChange(val)"
            @current-change="(val) => handleCurrentChange(val)"
            :current-page="currentPage"
            :page-sizes="[10,20,30]"
            :page-size=this.pageSize
            layout="->,total, sizes, prev, pager, next, jumper"
            :total= this.total
            style="margin-left:auto;">
        </el-pagination>
    </div>
</template>

<script>
import{Loading}from'element-ui';
import VennchartVue from '@/chart/Vennchart.vue'; 
export default ({
    components:{
        VennchartVue
    },
    data(){
        return{
            sets:null,
            activeOmics:"snp",
            omicsOption:[{
                value: 'snp',
                label: 'SNP'
                },{
                value: 'gene',
                label: 'Gene'
                },{
                value: 'rna',
                label: 'ncRNA'
                },
            //     {                
            //     value: 'methylation',
            //     label: 'Methylation'
            // }
        ],
            geneFields: [
                { key: "disease", label: "Disease", sortable: true,minWidth:120},
                { key: "gene_id", label: "Gene ID", sortable: true,minWidth:100},
                { key: "gene_name", label: "Gene name", sortable: true,minWidth:120},
                { key: "gene_aliases", label: "Gene aliases", sortable: true,minWidth:130},
                { key: "gene_type", label: "Gene type", sortable: true,minWidth:120},
                { key: "score_dgn", label: "Score_dgn", sortable: true,minWidth:120},
                { key: "map_location", label: "Map location", sortable: true,minWidth:130},
                { key: "chromosome", label: "Chromosome", sortable: true,minWidth:140},
                { key: "start", label: "Start",sortable: true,minWidth:95},
                { key: "end", label: "End", sortable: true,minWidth:95},
                { key: "disease_cui", label: "Disease-CUI", sortable: true,minWidth:250},
                { key: "source", label: "Source", sortable: true,minWidth:120}
            ],
            rnaFields: [
                { key: "disease", label: "Disease", sortable: true,minWidth:120},
                { key: "gene_id", label: "Gene ID", sortable: true,minWidth:100},
                { key: "gene_name", label: "Gene name", sortable: true,minWidth:120},
                { key: "rna_name", label: "Original name", sortable: true,minWidth:140},
                { key: "gene_aliases", label: "Gene aliases", sortable: true,minWidth:130},
                { key: "gene_type", label: "RNA type", sortable: true,minWidth:120},
                { key: "score_dgn", label: "Score_dgn", sortable: true,minWidth:120},
                { key: "map_location", label: "Map location", sortable: true,minWidth:130},
                { key: "chromosome", label: "Chromosome", sortable: true,minWidth:140},
                { key: "start", label: "Start",sortable: true,minWidth:95},
                { key: "end", label: "End", sortable: true,minWidth:95},
                { key: "disease_cui", label: "Disease-CUI", sortable: true,minWidth:130},
                { key: "source", label: "Source", sortable: true,minWidth:120},
            ],
            snpFields: [
                { key: "disease", label: "Disease", sortable: true,minWidth:120},
                { key: "snp", label: "SNP ID", sortable: true,minWidth:120},
                { key: "allele", label: "Allele", sortable: true,minWidth:120},
                { key: "score_dgn", label: "Score_dgn", sortable: true,minWidth:120},
                { key: "chromosome", label: "Chromosome", sortable: true,minWidth:140},
                { key: "position", label: "Position",sortable: true,minWidth:95},
                { key: "gene", label: "Gene", sortable: true,minWidth:120},
                { key: "disease_cui", label: "Disease-CUI", sortable: true,minWidth:130},
                { key: "source", label: "Source", sortable: true,minWidth:120},
            ], 
            methylationFields: [
                { key: "disease", label: "Disease", sortable: true,minWidth:120},
                { key: "probe", label: "Probe ID", sortable: true,minWidth:120},
                { key: "gene_id", label: "Gene ID", sortable: true,minWidth:120},
                { key: "gene_name", label: "Gene Name",sortable: true,minWidth:130},
                { key: "gene_aliases", label: "Gene aliases", sortable: true,minWidth:130},
                { key: "map_location", label: "Map location", sortable: true,minWidth:130},
                { key: "chromosome", label: "Chromosome", sortable: true,minWidth:140},
                { key: "probe_position", label: "Probe position", sortable: true,minWidth:150},
                { key: "start", label: "Start", sortable: true,minWidth:95},
                { key: "end", label: "End", sortable: true,minWidth:95},
                { key: "source", label: "Source", sortable: true,minWidth:120}
            ], 
            vennFields:null,
            tableData:[],
            //table
            currentPage:1,
            pageSize:10,
            total:0,
        }
    },
    methods:{
        click(sets){
            this.sets="Intersection data of ["+sets+"]"
            this.getData(sets)
        },
        selectChanged(){
            this.currentPage=1
            this.tableData=[]
            switch(this.activeOmics){
                case 'snp':
                    this.vennFields=this.snpFields
                    break;
                case 'gene':
                    this.vennFields=this.geneFields
                    break;
                case 'rna':
                    this.vennFields=this.rnaFields
                    break;
                case 'methylation':
                    this.vennFields=this.methylationFields
                    break;
            }
            this.sets="Intersection data of ["+["Major depressive disorder", "Schizophrenia"]+"]"
            this.getData(["Major depressive disorder", "Schizophrenia"])
            this.$refs.table.clearSort()
        },
        getData(sets){
            this.currentPage=1
            var loadingInstanceTable = Loading.service({
                target:document.querySelector('#table')
            });
            this.axios.get(this.GLOBAL.rootAddress+'visualization/Shared/'+this.activeOmics,{
            params: { 
                'disease':sets+ ''
                }
            })
            .then(response=> {       
                loadingInstanceTable.close();
                this.tableData=response.data; 
                this.total=this.tableData.length
            })
            .catch(error=> {
                loadingInstanceTable.close();
                console.log(error);
            });
        },
        handleSizeChange(val) {
            this.pageSize=val;
        },
        handleCurrentChange(val) {
            this.currentPage = val;
        },
        
        sortChange(column, prop, order){
            this.currentPage=1
            if(column.order === "ascending"){
                this.tableData = this.tableData.sort((a,b)=>this.compareTwo(a[column.prop],b[column.prop],"ascending"))
            }else if(column.order === "descending"){
                this.tableData = this.tableData.sort((a,b)=>this.compareTwo(a[column.prop],b[column.prop],"descending"))
            }
        },
        compareTwo(value1,value2,sort){
            if(value1==null)value1=""
            if(value2==null)value2=""
            function isNumberV(val) {
                var regPos = /^\d+(\.\d+)?$/; //非负浮点数
                var regNeg =
                /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
                if (regPos.test(val) || regNeg.test(val)) {
                    return true;
                } else {
                    return false;
                }
            }
            if (!isNumberV(value1) && !isNumberV(value2)) {
                const res = value1.localeCompare(value2, "en");
                    return sort === "ascending" ? res : -res;
            } else {
                if (sort === "ascending") {
                    return value1 - value2;
                } else {
                    return value2 - value1;
                }
            }
        }
    },
    mounted(){
        this.vennFields=this.snpFields
        this.sets="Intersection data of ["+["Major depressive disorder", "Schizophrenia"]+"]"
        this.getData(["Major depressive disorder", "Schizophrenia"])
    }
})
</script>
